export const SET_REFKEY_TABLE = "SET_REFKEY_TABLE";
export const SET_SELECTED_ANALYSISID = "SET_SELECTED_ANALYSISID";
export const SET_EXPAND_ITEM_VALUTS = "SET_EXPAND_ITEM_VALUTS";
export const ON_ANALYSIS_SELECT = "ON_ANALYSIS_SELECT";
export const EXPAND_TO_ITEM = "EXPAND_TO_ITEM";
export const UPDATE_EXPAND_ITEM_VALUE_LIST = "UPDATE_EXPAND_ITEM_VALUE_LIST";
export const SET_STRATEGYID_AND_ANALYSISID = "SET_STRATEGYID_AND_ANALYSISID";